import { render, staticRenderFns } from "./createImg_child.vue?vue&type=template&id=79a291f8&scoped=true&"
import script from "./createImg_child.vue?vue&type=script&lang=js&"
export * from "./createImg_child.vue?vue&type=script&lang=js&"
import style0 from "./createImg_child.vue?vue&type=style&index=0&id=79a291f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a291f8",
  null
  
)

export default component.exports